import {message} from 'ant-design-vue'
import Cookies from 'js-cookie'
export default function ({$axios, store, isDev}) {

	$axios.onError(error => {
		throw error;
	})

	$axios.onRequest(config => {
		// 解决IE浏览器下, 请求被缓存的问题
		config.headers['Cache-Control'] = 'no-cache, no-store' // 清除缓存
		config.headers['Pragma'] = 'no-cache' // 清除缓存
		if (config.url.indexOf('?') > -1) {
			config.url = config.url + `&n=${new Date().getTime()}`
		} else {
			config.url = config.url + `?n=${new Date().getTime()}`
		}
		// 所有请求加上当前语言环境
		// config.params = Object.assign({}, config.params, {
		// 	lang: store.state.locale
		// })
		config.headers['lh-year'] = '2022'
		config.headers['lh-forum-bid']='ccpit';
		let lang = store.state.locale
		if(store.state.locale=='en'){
			 lang = 'en_US'
		}
		config.headers['lh-language'] = lang
		if (Cookies.get('token')) {
			config.headers['lh-token'] = Cookies.get('token')
		}
	})

	$axios.onResponse(response => {
		const data = response.data

		if (data.errno) {
			if (data.errno === 401) {
				// store.dispatch('loginVisible', true)
			} else {
				if (data.errmsg) {
					if (process.client) message.error(data.errmsg)
				} else {
					if (process.client) message.error('Error')
				}
			}
			return Promise.reject(response)
		}
		return response
	})
}
